
import { ACTIVE_JOB } from '../../Constants/JobConstant'

const activeJobReducer = (state = null, action: { type: any; data: any; }) => {
  switch (action.type) {
    case ACTIVE_JOB:
      return action.data
    default:
      return state
  }
}

export default activeJobReducer
